<template>
    <div class="container" style="text-align: center; vertical-align: middle;">
        <i class="fas fa-search" style="font-size: 100px; color: brown;"></i>
        <h1>404 Not Found</h1>
        <p>No existe la pagina que esta solicitando.</p>
        <router-link to="/profile" class="back-home">Retornar a mi perfil.</router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: "NotFound"
  };
  </script>
  
  <style scoped>
        body {
            font-family: Arial, sans-serif;
            background-color: #f4f4f9;
            color: #333;
            text-align: center;
            padding: 50px;
            margin: 0;
        }

        .container {
            max-width: 600px;
            margin: 0 auto;
            padding: 20px;
            background-color: #fff;
            border-radius: 8px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        h1 {
            font-size: 3em;
            color: #e74c3c;
            margin-bottom: 20px;
        }

        p {
            font-size: 1.2em;
            color: #666;
            margin-bottom: 20px;
        }

        .padlock {
            font-size: 6em;
            color: #e74c3c;
            margin-bottom: 20px;
        }

        .back-home {
            padding: 10px 20px;
            font-size: 1.2em;
            color: #fff;
            background-color: #3498db;
            text-decoration: none;
            border-radius: 5px;
            transition: background-color 0.3s ease;
        }

        .back-home:hover {
            background-color: #2980b9;
        }
    </style>
